// extracted by mini-css-extract-plugin
export var animating = "_2t-3";
export var background = "_2t-6";
export var constrainHeight = "_2t-2";
export var dark = "_2t-4";
export var dropdown = "_2t-1";
export var leave = "_2t-5";
export var option = "_2t-7";
export var root = "_2t-0";